<template>
  <div>
    <VCard title="Fedback History 🙌">
      <VCardText>Coming Soon</VCardText>
    </VCard>
  </div>
</template>

<script setup>
definePage({
  meta: {
    name: 'feedback-history',
  },  
})
</script>
